import React, { useState, useEffect, useRef } from 'react';
import DelayLink from './DelayLink';
import { gridItemsData } from "./data";
import * as motion from "motion/react-client"
import styled from 'styled-components';


interface HeaderProps {
  children?: React.ReactNode;
}

const GridContainer = styled.div`
  display: grid;
  gap: 16px;
  text-align: left;
  align-items: left;
  box-sizing: border-box; 
`;

const GridItem = styled.div`
  color: #000000;
  display: flex;
  font-size: 0.7em;
  border: 3px solid black;
  border-radius: 8px;
`;

const ResponsiveGrid: React.FC<HeaderProps> = ({ children }) => {
  
  const [isLandscape, setIsLandscape] = useState(false);
  const marginRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkOrientation = () => {
      const isLandscapeMode = window.matchMedia('(orientation: landscape)').matches;
      setIsLandscape(isLandscapeMode);
    };
    // Initial check
    checkOrientation();
    // Listen for orientation changes
    window.addEventListener('resize', checkOrientation);
    // Cleanup event listener
    return () => {
      window.removeEventListener('resize', checkOrientation);
    };
  }, []);
  // Conditionally render the header only when not in landscape mode
  return (
       <div className="container">
    <div ref={marginRef}>
       {!isLandscape && (
    <GridContainer className="grid-container">
      {gridItemsData.map((item) => (
    <DelayLink  key={item.id}
          to={`/pages/` + item.id } delay={500}>
      <motion.div
            whileHover={{ scale: 0.95 }}
            whileTap={{ scale: 0.9 }}>
        <GridItem key={item.id}><div className="grid-item-first-portrait btnx"><div className="spacer"><div className="numboo">{item.title}</div></div><div className="spacer">&nbsp;</div><div className="spacer">&nbsp;</div><div className="spacer">&nbsp;</div></div><div className="grid-item-second"><div className="btnx-text header">{item.header}</div><div className="button-text">{item.text}</div></div></GridItem>
        </motion.div>
      </DelayLink>   
      ))}
    </GridContainer>
     )}
         {isLandscape && (  
        <GridContainer className="grid-container">
      {gridItemsData.map((item) => (
        <DelayLink  key={item.id}
          to={`/pages/` + item.id } delay={500}>
        <motion.div
               whileHover={{ scale: 0.95 }}
            whileTap={{ scale: 0.9 }}>
        <GridItem key={item.id}><div className="grid-item-first-landscape btnx"><div className="spacer"><div className="numboo">{item.title}</div></div><div className="spacer">&nbsp;</div><div className="spacer">&nbsp;</div><div className="spacer">&nbsp;</div></div><div className="grid-item-second"><div className="btnx-text header">{item.header}</div><div className="button-text">{item.text}</div></div></GridItem>
        </motion.div>
</DelayLink>   
      ))}
    </GridContainer>
      )}
    </div>
       </div>
  );
}
export default ResponsiveGrid;   